import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import { forgotOrg } from "../api";
import { SendEmailPage } from "../components/sso/send_email_page";
import { LoginStore } from "../store/login";

const ForgotOrg = () => {
  const dispatch = useDispatch();
  const { email } = useSelector(LoginStore.selectors.select());

  useEffect(() => {
    dispatch(LoginStore.actions.update({ successMessage: null }));
  }, [dispatch]);

  const onSubmit = () => ({ realemail }) => {
    dispatch(forgotOrg({ email: realemail }));
  };

  const onResubmit = () => () => {
    dispatch(forgotOrg({ email }));
    dispatch(
      LoginStore.actions.update({
        successMessage: "The link has been resent. Please check your email.",
      }),
    );
  };

  return (
    <SendEmailPage
      onSubmitAfter={onResubmit}
      onSubmitBefore={onSubmit}
      submitTextAfter="Resend Link"
      submitTextBefore="Email My Link"
      textBefore="Not to worry. Enter your email below and we’ll send you a link to sign in."
      titleAfter="Please check your email."
      titleBefore="Don’t know your Organization?"
    />
  );
};

export { ForgotOrg };
